<div class="waterfall-transfers-banner">
  <button class="dismiss-btn" (click)="dismiss()" type="button">
    <ng-icon name="heroXMark"></ng-icon>
  </button>

  <div class="banner-illustration" aria-hidden="true">
    <svg viewBox="0 0 210 102" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
      <defs>
        <linearGradient id="wf-arrow-grad" x1="0.983" y1="8.817" x2="4.483" y2="12.317" gradientUnits="userSpaceOnUse">
          <stop stop-color="#AD5DEF" stop-opacity="0.5"/>
          <stop offset="1" stop-color="#9332E0"/>
        </linearGradient>
      </defs>

      <!-- Connector arrows (A→B, B→C) -->
      <g transform="translate(14 26) scale(0.855)">
        <path d="M0.65 0.65V12.3167C0.65 13.4213 1.54543 14.3167 2.65 14.3167H7.65M5.65 11.65L8.31667 14.3167L5.65 16.9833" fill="none" stroke="url(#wf-arrow-grad)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <g transform="translate(34 51) scale(0.855)">
        <path d="M0.65 0.65V12.3167C0.65 13.4213 1.54543 14.3167 2.65 14.3167H7.65M5.65 11.65L8.31667 14.3167L5.65 16.9833" fill="none" stroke="url(#wf-arrow-grad)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
      </g>

      <!-- Row A (unanswered) -->
      <g transform="translate(4 4)" opacity="0.6">
        <rect width="106" height="20" rx="10" fill="#2a143c" fill-opacity="0.04" stroke="#2a143c" stroke-opacity="0.12" stroke-width="0.724"/>
        <circle cx="10" cy="10" r="8" fill="#2a143c" fill-opacity="0.16"/>
        <text class="wf-avatar" x="10" y="10" text-anchor="middle" dominant-baseline="central">A</text>
        <text class="wf-number" x="22" y="10" dominant-baseline="central">(555) 234-4567</text>
        <path transform="translate(90 4)" d="M4 4L8 8M8 4L4 8" stroke="#2a143c" stroke-opacity="0.5" stroke-linecap="round"/>
      </g>

      <!-- Row B (unanswered) -->
      <g transform="translate(24 29)" opacity="0.6">
        <rect width="106" height="20" rx="10" fill="#2a143c" fill-opacity="0.04" stroke="#2a143c" stroke-opacity="0.12" stroke-width="0.724"/>
        <circle cx="10" cy="10" r="8" fill="#2a143c" fill-opacity="0.16"/>
        <text class="wf-avatar" x="10" y="10" text-anchor="middle" dominant-baseline="central">B</text>
        <text class="wf-number" x="22" y="10" dominant-baseline="central">(555) 234-5123</text>
        <path transform="translate(90 4)" d="M4 4L8 8M8 4L4 8" stroke="#2a143c" stroke-opacity="0.5" stroke-linecap="round"/>
      </g>

      <!-- Row C (answered) -->
      <g transform="translate(44 54)">
        <rect width="106" height="20" rx="10" fill="#ffffff" stroke="#2a143c" stroke-opacity="0.04" stroke-width="1"/>
        <circle cx="10" cy="10" r="8" fill="#c48af6"/>
        <text class="wf-avatar wf-avatar-answered" x="10" y="10" text-anchor="middle" dominant-baseline="central">C</text>
        <text class="wf-number wf-number-answered" x="22" y="10" dominant-baseline="central">(555) 234-9185</text>
        <path transform="translate(90 4)" d="M3.5 6.5L5 8L8.5 4" fill="none" stroke="#10B981" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
    </svg>
  </div>

  <div class="banner-bottom">
    <p class="eyebrow">{{ 'TRANSFER_CALLS.WATERFALL.SIDEBAR_BANNER_EYEBROW' | translate }}</p>
    <p class="title-text" [innerHTML]="'TRANSFER_CALLS.WATERFALL.SIDEBAR_BANNER_TITLE' | translate"></p>
  </div>

  <button class="cta-btn" (click)="navigate()" type="button" [attr.aria-label]="'TRANSFER_CALLS.WATERFALL.SIDEBAR_BANNER_EYEBROW' | translate">
    <ng-icon name="heroArrowRightMini"></ng-icon>
  </button>
</div>
